import LoadingButton from '../../ui/LoadingButton';
import { mainColors } from '../../../styling/theme';

interface PreviousPositionDateButtonProps {
  currentPositionDate: string;
  activePositionDate: string;
  handler: () => void;
  alteredColor?: boolean;
  isLoading?: boolean;
}

export const PreviousPositionDateButton = ({
  currentPositionDate,
  activePositionDate,
  handler,
  alteredColor,
  isLoading = false,
}: PreviousPositionDateButtonProps) => {
  const isToday = currentPositionDate === activePositionDate;
  const textColor = alteredColor ? mainColors.mainGold : '#424242';
  const label = isToday
    ? 'Compare with previous position date'
    : `View today's position date (${activePositionDate})`;

  return (
    <LoadingButton
      onClick={handler}
      isLoading={isLoading}
      className={`px-2 py-1 text-xs font-normal normal-case border border-gray-100 rounded mr-2 ${isLoading
        ? 'bg-mainblue text-white hover:bg-mainblue/90'
        : 'bg-white text-[inherit] hover:bg-gray-100 hover:text-mainblue'
        }`}
      style={{ color: isLoading ? undefined : textColor }}
    >
      {label}
    </LoadingButton>
  );
};
